const selectors = {
    inputBox : document.querySelector('#input-orderid input')
  };

  class TemplateOrderTrackerJS {
    constructor() {
        this.form();
    }

    form(){
        // Custom code for Order Tracker page goes here
        let name = new URLSearchParams(document.location.search);
        let orderId = name.get("orderid");
        if (orderId){
            selectors.inputBox.value = `${orderId}`;
        }
        
    }
}

typeof TemplateOrderTrackerJS !== 'undefined' && new TemplateOrderTrackerJS();



